export default [
    {
        meta: {
            title: 'Смены',
        },
        path: '',
        name: 'work-days-list',
        component: () => import('@/views/workDays/WorkDaysList.vue')
    }
]